import { checkIfDomainExists, removeExtension } from "../helpers/helpers"

export function getImageUrl(name) {
    let currentDomain = window.location.hostname
   
   if(currentDomain.includes("localhost"))
   {
    return "images/"+name
   }
    return "/documents/d/hayak/"+ removeExtension(name)
}

export function openImageInNewTab(url) {
    if (url) {
       
        window.open(checkIfDomainExists(url), "_blank");
    }
}